import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/videos';

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  const next = useCallback(() => {
    goTo((current + 1) % banners.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative h-[420px] md:h-[600px] overflow-hidden">
      {banners.map((banner, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-600 ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={banner.cover}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 z-20 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className={`transition-all duration-500 ${
              isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
            }`}>
              <span className="inline-block px-3 py-1 bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium rounded-full mb-4">
                {banners[current].category}
              </span>
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-3 md:mb-4 leading-tight">
                {banners[current].title}
              </h1>
              <p className="text-sm md:text-base text-background-200 max-w-xl mb-6 md:mb-8 leading-relaxed">
                {banners[current].subtitle}
              </p>
              <Link
                to={banners[current].link}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm md:text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <span>立即观看</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line text-lg"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 z-20 flex justify-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
              index === current
                ? 'bg-primary-500 w-8'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}